import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { IdValueObject } from '../../../../utility/model/id-value-object.model';

export class SharingVendorId extends IdValueObject {
  static create(value: string): SharingVendorId {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new SharingVendorId(value);
  }
}
